import React from 'react';
import { Trans } from '@lingui/react/macro';
import { BaseProduct } from '@/types';
import { convertToUnit, unitAbbreviations } from '@/utils/unit-of-measurements';
import theme from './ProductDetails.module.scss';
import { useGetDefaultProjectUnitOfMeasurement } from '@/utils/hooks';
import { ConfiguratorProductDto } from '@/services/configurator';

export interface ProductDetailsProps {
    product: BaseProduct | ConfiguratorProductDto;
    className?: string;
    layout?: 'grid' | 'list';
}

const MeasurementDetailsField: React.FC<{
    hideEmpty?: boolean;
    caption: React.ReactNode;
    value: number | null;
}> = ({ caption, value, hideEmpty = false }) => {
    const unitOfMeasurement = useGetDefaultProjectUnitOfMeasurement()!;
    const unitAbbreviation = unitAbbreviations[unitOfMeasurement];
    const hasValue = value !== null;

    if (hideEmpty && !hasValue) {
        return null;
    }

    return (
        <>
            <span className={theme.caption}>{caption}:</span>
            {hasValue ? (
                <span className={theme.value}>
                    {convertToUnit(value, unitOfMeasurement)}
                    {unitAbbreviation}
                </span>
            ) : (
                <span className="text-missing">
                    <Trans>N/A</Trans>
                </span>
            )}
        </>
    );
};

export const ProductDetails: React.FC<ProductDetailsProps> = ({ product, className, layout = 'grid' }) => {
    return (
        <div className={`${theme.details} ${theme[layout]} ${className || ''}`}>
            <MeasurementDetailsField value={product.widthCm} caption={<Trans>Width</Trans>} hideEmpty />
            <MeasurementDetailsField value={product.heightCm} caption={<Trans>Height</Trans>} hideEmpty />
            <MeasurementDetailsField value={product.lengthCm} caption={<Trans>Length</Trans>} hideEmpty />
            <MeasurementDetailsField value={product.depthCm} caption={<Trans>Depth</Trans>} hideEmpty />

            {product.sku && (
                <>
                    <span className={theme.caption}>
                        <Trans>Product ID</Trans>:
                    </span>
                    <span className={theme.value}>{product.sku}</span>
                </>
            )}
            {/* {product.productLink && (
                <ExternalLink className={theme.link} href={product.productLink} target="_blank">
                    <FontAwesomeIcon icon={faExternalLink} />
                    <Trans>Product link</Trans>
                </ExternalLink>
            )} */}
        </div>
    );
};
